import { render, staticRenderFns } from "./PleaseUpdate.vue?vue&type=template&id=fecb90bc&scoped=true"
import script from "./PleaseUpdate.vue?vue&type=script&lang=js"
export * from "./PleaseUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecb90bc",
  null
  
)

export default component.exports